/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import { AlertDialog, Field, Input } from '@components/design-system';
import * as Styles from '@components/modals/styles';
import { SelectorCurrency } from '@components/selector-currency';
import { ILooseObject } from '@interface/loose-object';
import { auctionCreate } from '@lib/beacon';
import { TezToMut } from '@utils/format';

export interface IAuctionCreate {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  platformName?: string;
  tokenKT?: string;
  tokenId?: number;
}

export const AuctionCreate: FC<IAuctionCreate> = ({ open, onOpenChange, tokenKT, tokenId, platformName }) => {
  const [values, setValues] = useState<ILooseObject>({
    currency: { error: false, data: null },
    price: { error: false, data: null },
    duration: { error: false, data: null },
  });

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.price.data) {
      setError('price', '"Price" is missing');
      valid = false;
    }

    if (!values.duration.data) {
      setError('duration', '"Time" is missing');
      valid = false;
    }

    return valid;
  };

  const handleConfirm = () => {
    if (validate()) {
      auctionCreate(TezToMut(values.price.data), Number(values.duration.data), tokenKT!, tokenId!, platformName!);

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Create Auction"
      description="You're about to create an auction."
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        <Field uid="currency" label="Currency" error={values.currency.error}>
          <SelectorCurrency onChange={(value: string) => handleChange('currency', value)} />
        </Field>
        <Field uid="price" label="Start price" tooltip="Start price of the auction in XTZ" error={values.price.error}>
          <Input
            type="number"
            min={0}
            placeholder="e.g.: 7"
            onChange={(value: string) => handleChange('price', value)}
          />
        </Field>
        <Field
          uid="duration"
          label="Time (hours)"
          tooltip="Duration for the auction in hours."
          error={values.duration.error}
        >
          <Input
            type="number"
            min={24}
            placeholder="e.g.: 24"
            onChange={(value: string) => handleChange('duration', value)}
          />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
